<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-250">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-11">
                        <h2 class="display-3 text-white">We would love to hear from you!</h2>
                        <p class="lead text-white">Whether you want to know more about the experiences or have some feedback, we're here to help.</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Get in touch with us</h4>
                            <p class="mt-0 mb-3">Let us know your questions or concerns and we will respond as quickly as possible.</p>
                            <small v-show="invalidName" class="text-danger">Please enter a name!</small>
                            <base-input
                                        alternative
                                        v-model="name"
                                        placeholder="Your name"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <small v-show="invalidEmail" class="text-danger">Please enter a valid email!</small>
                            <base-input alternative
                                        v-model="email"
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <small v-show="invalidSubject" class="text-danger">Please enter a subject!</small>
                            <base-input alternative
                                        v-model="subject"
                                        placeholder="Subject">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative"
                                              v-model="message"
                                              name="name" rows="4"
                                              cols="80" placeholder="Type a message..."></textarea>
                            </base-input>
                            <base-button type="default" v-on:click="submitForm" round block size="lg">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-secondary">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-square-pin" class="mb-4" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3 class="mb-4">Contact Info</h3>
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.4428230386716!2d-121.97536058459971!3d37.56818903179091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fc06128beea47%3A0x78cdcc517c6ce050!2s555%20Mowry%20Ave%2C%20Fremont%2C%20CA%2094536!5e0!3m2!1sen!2sus!4v1647627316219!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 mt-3 order-md-2">
                        <div class="text-center">
                            <img src="img/brand/pandas/conspiracy.png" style="width: 200px;" class="mt-3 img-fluid">
                        </div>
                        <ul class="list-unstyled mt-2">
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-pin-3"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0">{{contactInfo.address1}}</h6>
                                        <h6 class="mb-0">{{contactInfo.address2}}</h6>
                                    </div>
                                </div>
                            </li>
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-mobile-button"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0">{{contactInfo.phone}}</h6>
                                    </div>
                                </div>
                                <!--<div class="d-flex align-items-center">-->
                                <!--<badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>-->
                                <!--<h6 class="mb-0">Amazing page examples</h6>-->
                                <!--</div>-->
                            </li>
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-email-83"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0"><a
                                                href="mailto:contact@offthecouchgames.com"
                                                v-on:click="tracker('Contact', 'Emailed contact', 'Link from Contact Info section on contact page')"
                                        >{{contactInfo.email}}</a></h6>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <modal :show.sync="modals.modal1">
            <div class="text-center">
                <img src="img/brand/pandas/conspiracy.png" style="width: 150px;" class="mt-3img-fluid">
                <h6 class="mt-3">Thank you for contacting us!</h6>
                <p>We'll get back to you soon</p>
            </div>
            <div class="row">
                <div class="col-md-9">

                </div>
                <div class="col-md-3">
                    <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Close
                    </base-button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Modal from "../components/Modal";
    import axios from "axios";
    export default {
        name: "Contact",
        components: { Modal },
        data () {
            return {
                name: null,
                email: null,
                subject: null,
                message: null,
                invalidName: false,
                invalidEmail: false,
                invalidSubject: false,
                modals: {
                    modal1: false
                },
                contactInfo: {
                    address1: "555 Mowry Avenue",
                    address2: "Fremont, CA 94536",
                    phone: "+1 (408) 478-2341",
                    email: "contact@offthecouchgames.com"
                },
            }
        },
        methods: {
            submitForm () {
                const url = "https://main-api.offthecouchgames.com/contacts"
                var data = {
                    "contact_name" : this.name,
                    "email" : this.email,
                    "subject" : this.subject,
                    "message" : this.message

                }
                axios.post(url, data)
                    .then(response => {

                        this.name = null
                        this.email = null
                        this.subject = null
                        this.message = null
                        this.invalidName = false
                        this.invalidEmail = false
                        this.invalidSubject = false
                        this.modals.modal1 = true

                        //GA event
                        this.tracker('Contact', 'Submitted contact form', 'Contact us page')

                    })
                    .catch(err => {
                        if(err.response.data.includes("email")){
                            this.invalidEmail = true
                        } else {
                            this.invalidEmail = false
                        }
                        if(err.response.data.includes("name")){
                            this.invalidName = true
                        } else {
                            this.invalidName = false
                        }
                        if(err.response.data.includes("subject")){
                            this.invalidSubject = true
                        } else {
                            this.invalidSubject = false
                        }

                    })
            },
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>

</style>
